<template>
  <div class="bar_Box e-flex jc-between box">
    <span class="fs-md fw-6">{{ text }}</span>
    <span>带<span class="text-red">*</span>必填</span>
  </div>
</template>
<script>
export default {
  props: {
    text: '',
  },
}
</script>
<style scoped>
.box {
  height: 60px;
  text-align: center;
  padding: 15px 25px;
  overflow: hidden;
  color: #333333;
  background: #edf5fa;
  margin: 15px auto;
  width: 90%;
}
</style>
